import Result from "@Core/Result";
import { ServiceBase } from "@Core/ServiceBase";
import { IEmptyObject } from "@Components/shared/types";
import { IUserAcceptedTerm, ITerm, ITerms } from "@Models/ITerms";

export default class TermsService extends ServiceBase {
    public async getAllTerms(): Promise<Result<{ terms: ITerms }>> {
        return await this.requestJson({
            url: "/api/Terms/",
            method: "GET",
        });
    }

    public async createTerms(model: { termsType: string; content: string }): Promise<Result<IEmptyObject>> {
        return await this.requestJson({
            url: "/api/Terms/Create",
            method: "POST",
            data: model,
        });
    }

    public async updateTerms(
        termsVersionId: string,
        model: { termsType: string; content: string }
    ): Promise<Result<IEmptyObject>> {
        return await this.requestJson({
            url: `/api/Terms/Update/${termsVersionId}`,
            method: "PATCH",
            data: model,
        });
    }

    public async publishTerms(termsVersionId: string): Promise<Result<IEmptyObject>> {
        return await this.requestJson({
            url: `/api/Terms/Publish/${termsVersionId}`,
            method: "PATCH",
        });
    }

    public async getLatestTerms(type: string): Promise<Result<ITerm>> {
        return await this.requestJson({
            url: `/api/Terms/latest?type=${type}`,
            method: "GET",
        });
    }

    public async createTermsAction(termsVersionId: string, accepted: boolean): Promise<Result<IEmptyObject>> {
        return await this.requestJson({
            url: `/api/Terms/Action?terms-version-id=${termsVersionId}&accepted=${accepted}`,
            method: "POST",
        });
    }

    public async getUserAcceptedTerms(
        type: string,
        latest: boolean
    ): Promise<Result<{ userAcceptedTerms: IUserAcceptedTerm[] }>> {
        return await this.requestJson({
            url: `/api/Terms/User?type=${type}&latest=${latest}`,
            method: "GET",
        });
    }
}
